/**
 * Das deutsche Wörterbuch — die Quelle.
 *
 * Aufgeteilt nach Ort statt in eine Datei: Wer an einem Dialog arbeitet, soll
 * dessen Texte beieinander finden und nicht in tausend Zeilen suchen. Die
 * Zusammenführung hier ist flach; die Schlüssel tragen ihren Bereich im Namen.
 */
import { common } from './common.js';
import { domain } from './domain.js';
import { pages } from './pages.js';
import { dialogs } from './dialogs.js';
import { canvas } from './canvas.js';
import { server } from './server.js';
export const de = {
    ...common,
    ...domain,
    ...pages,
    ...dialogs,
    ...canvas,
    ...server,
};
//# sourceMappingURL=index.js.map